export const countryOptions = [{"name": "Argentina", "code": "+54"}, 
    {"name": "Armenia", "code": "+374"}, 
    {"name": "Australia", "code": "+61"}, 
    {"name": "Austria", "code": "+43"}, 
    {"name": "Azerbaijan", "code": "+994"}, 
    {"name": "Bangladesh", "code": "+880"}, 
    {"name": "Belarus", "code": "+375"}, 
    {"name": "Belgium", "code": "+32"},
     {"name": "Bhutan", "code": "+975"},
      {"name": "Bosnia and Herzegovina","code": "+387"},
       {"name": "Brazil", "code": "+55"}, 
       {"name": "Brunei", "code": "+673"}, 
       {"name": "Bulgaria", "code": "+359"}, 
       {"name": "Canada", "code": "+1"}, 
       {"name": "Chile", "code": "+56"}, 
       {"name": "China", "code": "+86"}, 
       {"name": "Colombia", "code": "+57"},
        {"name": "Croatia", "code": "+385"}, 
        {"name": "Cyprus", "code": "+357"}, 
        {"name": "Czech Republic", "code": "+420"}, 
        {"name": "Denmark", "code": "+45"}, 
        {"name": "Dominican Republic", "code": "+1-809"},
         {"name": "Ecuador", "code": "+593"}, 
         {"name": "Estonia", "code": "+372"}, 
         {"name": "Fiji", "code": "+679"}, 
         {"name": "Finland", "code": "+358"}, 
         {"name": "France", "code": "+33"}, 
         {"name": "Georgia", "code": "+995"}, 
         {"name": "Germany", "code": "+49"}, 
         {"name": "Greece", "code": "+30"}, 
         {"name": "Guatemala", "code": "+502"}, 
         {"name": "Honduras", "code": "+504"}, 
         {"name": "Hungary", "code": "+36"}, 
         {"name": "Iceland", "code": "+354"}, 
         {"name": "India", "code": "+91"}, 
         {"name": "Indonesia", "code": "+62"}, 
         {"name": "Iran", "code": "+98"}, 
         {"name": "Ireland", "code": "+353"},
         {"name": "Israel", "code": "+972"}, 
         {"name": "Italy", "code": "+39"}, 
         {"name": "Japan", "code": "+81"}, 
         {"name": "Kazakhstan", "code": "+7"}, 
         {"name": "Kuwait", "code": "+965"}, 
         {"name": "Kyrgyzstan", "code": "+996"}, 
         {"name": "Laos", "code": "+856"}, 
         {"name": "Latvia", "code": "+371"},
          {"name": "Liechtenstein", "code": "+423"},
           {"name": "Lithuania", "code": "+370"}, 
           {"name": "Luxembourg", "code": "+352"}, 
           {"name": "Malaysia", "code": "+60"}, 
           {"name": "Malta", "code": "+356"},
            {"name": "Mexico", "code": "+52"},
             {"name": "Moldova", "code": "+373"}, 
             {"name": "Monaco", "code": "+377"}, 
             {"name": "Mongolia", "code": "+976"},
              {"name": "Montenegro", "code": "+382"},
               {"name": "Myanmar", "code": "+95"}, 
               {"name": "Nepal", "code": "+977"}, 
               {"name": "Netherlands", "code": "+31"}, 
               {"name": "New Zealand", "code": "+64"},
                {"name": "North Macedonia", "code": "+389"},
                 {"name": "Norway", "code": "+47"}, 
                 {"name": "Pakistan", "code": "+92"}, 
                 {"name": "Panama", "code": "+507"},
                  {"name": "Paraguay", "code": "+595"}, 
                  {"name": "Peru", "code": "+51"},
                  {"name": "Philippines", "code": "+63"},
                   {"name": "Poland", "code": "+48"}, 
                   {"name": "Portugal", "code": "+351"},
                    {"name": "Qatar", "code": "+974"}, {"name": "Romania", "code": "+40"}, {"name": "Russia", "code": "+7"}, {"name": "San Marino", "code": "+378"}, {"name": "Serbia", "code": "+381"}, {"name": "Singapore", "code": "+65"}, {"name": "Slovakia", "code": "+421"}, {"name": "Slovenia", "code": "+386"}, {"name": "South Korea", "code": "+82"}, {"name": "Spain", "code": "+34"}, {"name": "Sri Lanka", "code": "+94"}, {"name": "Sweden", "code": "+46"}, {"name": "Switzerland", "code": "+41"}, {"name": "Taiwan", "code": "+886"}, {"name": "Tajikistan", "code": "+992"}, {"name": "Thailand", "code": "+66"}, {"name": "Turkey", "code": "+90"}, {"name": "Turkmenistan", "code": "+993"}, {"name": "Ukraine", "code": "+380"}, {"name": "United Kingdom", "code": "+44"}, {"name": "United States", "code": "+1"}, {"name": "Uruguay", "code": "+598"}, {"name": "Uzbekistan", "code": "+998"}, {"name": "Vatican City", "code": "+379"},
    {"name": "Venezuela", "code": "+58"}, {"name": "Vietnam", "code": "+84"}];